import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

import { StatCard } from './stat-card';
import type { StatsData } from '../../model/types';

interface StockOnHandStatsProps {
  stats: StatsData | null;
}

export function StockOnHandStats({ stats }: StockOnHandStatsProps) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <StatCard label="Current Stock" value={stats.totalVolume} />
      <StatCard label="Expiring Soon" value={stats.expiringSOH} variant="warning" />
      <StatCard
        label="Long Standing"
        value={
          <div className="flex items-center gap-2">
            <span className="text-2xl font-semibold">{stats.longStandingPerc}</span>
            <Badge variant="secondary">90+ days</Badge>
          </div>
        }
      />
      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Issues</div>
        <div className="text-lg font-semibold text-destructive">
          Lost: {stats.lossTotal} | Damaged: {stats.damageTotal}
        </div>
      </Card>
    </div>
  );
}
